import { render, staticRenderFns } from "./MoonPrice.vue?vue&type=template&id=8f3b1be6&scoped=true&"
import script from "./MoonPrice.vue?vue&type=script&lang=js&"
export * from "./MoonPrice.vue?vue&type=script&lang=js&"
import style0 from "./MoonPrice.vue?vue&type=style&index=0&id=8f3b1be6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f3b1be6",
  null
  
)

export default component.exports